import ValueGrid from "components/grid/value-grid";
import Block from "components/layout/block";
import { parse } from "lib/locale";
import { ListEntity } from "models/list-entity";
import { FunctionComponent, useEffect, useState } from "react";
import { useLocale } from "stores/hooks/locale";
import { StyledEntityEditButton } from "./single-list-entity-block.styles";
import { EntityCollection } from "models/list-user-entity-collection";
import { useListUser } from "stores/hooks/list-user";
import {
  adminDoGetEntityCollections,
  adminDoPostEntityCollection,
} from "services/admin/list-user-entity-collection";
import { useList } from "stores/hooks/list";
import EditEntityModal from "../entities/edit-entity-modal";
import { fetchAdminListUser } from "stores/actions/list-user";
import { faPen } from "components/icon-library";

interface SingleListEntityBlockProps {
  listEntity: ListEntity;
}

const SingleListEntityBlock: FunctionComponent<SingleListEntityBlockProps> = ({
  listEntity,
}) => {
  const listUser = useListUser();
  const list = useList();
  const locale = useLocale();
  const [entityCollection, toggleEntityCollection] = useState<
    EntityCollection | undefined
  >(undefined);
  const [edit, toggleEdit] = useState(false);

  const update = async () => {
    // get collections
    if (list && listUser) {
      const entityCollections = await adminDoGetEntityCollections(
        list.uuid,
        listUser.uuid,
        listEntity.uuid,
      );
      let ec = entityCollections[0];
      if (!ec) {
        ec = await adminDoPostEntityCollection(
          list.uuid,
          listUser.uuid,
          listEntity.uuid,
          { entityCollectionValues: [] },
        );
      }

      toggleEntityCollection(ec);
    }
  };

  useEffect(() => {
    if (list && listUser) {
      update();
    }
  }, [list?.uuid, listUser?.uuid]);

  if (!list || !listUser || !entityCollection) {
    return null;
  }

  return (
    <Block title={parse(listEntity.name, locale)}>
      <ValueGrid
        listEntityFields={listEntity.listEntityFields || []}
        entityCollections={[entityCollection]}
      />
      <StyledEntityEditButton
        type="tertiary"
        postIcon={faPen}
        onClick={() => toggleEdit(true)}
      >
        Muokkaa tietoja
      </StyledEntityEditButton>
      {edit && (
        <EditEntityModal
          listEntity={listEntity}
          entityCollection={entityCollection}
          onUpdate={async () => {
            update();
            fetchAdminListUser(list, listUser.uuid);
          }}
          onClose={async () => toggleEdit(false)}
        />
      )}
    </Block>
  );
};

export default SingleListEntityBlock;
